// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_link-module__container--2xjHY"};